<template>
  <div>
    <b-row>
      <b-col cols="12" sm="3" v-if="segunBusqueda">
        <p class="text-muted mb-0">
          <small>
            Habitaciones a seleccionar
            <v-icon
              name="question"
              class="cur-pointer"
              v-b-tooltip.hover
              title="La ocupación de las habitaciones seleccionadas debe coincidir con la búsqueda"
            ></v-icon
            >:
          </small>
        </p>
      </b-col>
      <b-col cols="12" sm="9" v-if="segunBusqueda">
        <div class="float-sm-right">
          <b-badge
            :variant="v.tomado ? 'success' : 'warning'"
            class="mx-1 badge-as"
            v-for="(v, indexvc) in validHab"
            v-bind:key="indexvc"
          >
            {{ v.descripcion }}
            <v-icon clas="caption" color="black">{{ v.tomado ? "fas fa-check" : "fas fa-exclamation" }}</v-icon>
          </b-badge>
        </div>
      </b-col>
      <b-col cols="12" v-if="segunBusqueda">
        <hr />
      </b-col>
      <b-col cols="12" sm="6" class="text-center">
        <small class="text-muted float-left" v-if="request">
          {{ request.checkin | formatDMY }} al {{ request.checkout | formatDMY }} |
          {{ _$diffDias(request.checkin, request.checkout) }}
        </small>
      </b-col>
      <b-col cols="12" sm="6">
        <p class="mb-0 text-center float-lg-right">
          <small class="text-success"> {{ filtrados.hoteles.length }} hoteles disponibles </small>
          <small class="text-muted" v-if="filtrados.sinDispo.length > 0">
            | {{ filtrados.sinDispo.length }} hoteles sin disponibilidad
          </small>
        </p>
      </b-col>
    </b-row>
    <PanelHotel :hotel="h" :platformHere="platformHere" v-for="(h, index) in filtrados.hoteles" :key="index" />
    <PanelHotel
      :hotel="h"
      :platformHere="platformHere"
      v-for="(h, indexsin) in filtrados.sinDispo"
      :key="`sin${indexsin}`"
      :disponible="false"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex"
import Loading from "@/components/utiles/Loading.vue"
const PanelHotel = () => ({
  // The component to load (should be a Promise)
  component: import("@/components/hoteles/PanelHotel.vue"),
  // A component to use while the async component is loading
  loading: Loading,
  // A component to use if the load fails
  // error: ErrorComponent,
  // Delay before showing the loading component. Default: 200ms.
  delay: 1,
  // The error component will be displayed if a timeout is
  // provided and exceeded. Default: Infinity.
  timeout: 3000
})
export default {
  name: "contenedorRsHotel",
  components: {
    PanelHotel,
    Loading
  },
  mounted() {
    this.platformHere = new H.service.Platform({
      app_id: "oP7nVLruG1Re45H6IZ5h",
      app_code: "7APIzQkFxApBLXuczZa5aw",
      useHTTPS: true
    })
  },
  beforeCreate() {},
  methods: {
    openModalCarrito() {
      this.$parent.setModal()
    }
  },
  computed: {
    ...mapGetters("filtroHoteles", {
      filtrados: "getHotelesFiltrados",
      request: "getRq"
    }),
    ...mapGetters("carrito", {
      cantServicios: "getCantidadServicios",
      validHab: "getValidHab",
      segunBusqueda: "getValidarSegunBusqueda"
    })
  },
  data: function() {
    return {
      platformHere: null
    }
  }
}
</script>
